function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_951",
  "data-name": "Group 951"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_950",
  "data-name": "Group 950"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_657",
  "data-name": "Path 657",
  d: "M22.716,47.483A22.742,22.742,0,1,1,45.433,24.716,22.773,22.773,0,0,1,22.716,47.483Zm0-43.451A20.709,20.709,0,1,0,43.4,24.767,20.745,20.745,0,0,0,22.716,4.033Z",
  transform: "translate(0 -2)",
  fill: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_952",
  "data-name": "Group 952",
  transform: "translate(15.551 11.485)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_658",
  "data-name": "Path 658",
  d: "M41.526,36.847h-3.4V47.875H33.039V36.847H30.6v-4.32h2.439v-2.8c0-1.982.966-5.133,5.133-5.133h3.761v4.167H39.188c-.457,0-1.067.2-1.067,1.169v2.541h3.862Zm.61.1",
  transform: "translate(-30.6 -24.6)",
  fill: "#fff"
}));

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_953",
    "data-name": "Group 953",
    width: 45.433,
    height: 45.483,
    viewBox: "0 0 45.433 45.483",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.821de32a.svg";
export { ForwardRef as ReactComponent };